import { Type } from "@sinclair/typebox";
import { ContentStatus, SpiceLevel } from "../enums";
import { OPTION_TEXT_MAX } from "../limits";
/**
 * Admin contracts for the curated suggestion library. plan.md §1.3.
 * Players never see these routes; delivery during setup is a separate surface.
 */
export const SpiceLevelSchema = Type.Enum(SpiceLevel);
export const ContentStatusSchema = Type.Enum(ContentStatus);
export const SuggestionSchema = Type.Object({
    id: Type.String({ format: "uuid" }),
    text: Type.String({ minLength: 1, maxLength: OPTION_TEXT_MAX }),
    spice: SpiceLevelSchema,
    locale: Type.String(),
    pack: Type.String(),
    status: ContentStatusSchema,
    created_at: Type.String(),
    updated_at: Type.String(),
});
/** One suggestion as written by hand, before the database assigns anything. */
export const SuggestionInputSchema = Type.Object({
    text: Type.String({ minLength: 1, maxLength: OPTION_TEXT_MAX }),
    spice: SpiceLevelSchema,
    locale: Type.Optional(Type.String({ minLength: 1, maxLength: 16 })),
    pack: Type.Optional(Type.String({ minLength: 1, maxLength: 32 })),
    status: Type.Optional(ContentStatusSchema),
});
export const SuggestionCreateReqSchema = SuggestionInputSchema;
export const SuggestionCreateResSchema = SuggestionSchema;
export const SuggestionUpdateReqSchema = Type.Object({
    id: Type.String({ format: "uuid" }),
    text: Type.Optional(Type.String({ minLength: 1, maxLength: OPTION_TEXT_MAX })),
    spice: Type.Optional(SpiceLevelSchema),
    status: Type.Optional(ContentStatusSchema),
});
export const SuggestionListReqSchema = Type.Object({
    spice: Type.Optional(SpiceLevelSchema),
    status: Type.Optional(ContentStatusSchema),
    locale: Type.Optional(Type.String({ minLength: 1, maxLength: 16 })),
    pack: Type.Optional(Type.String({ minLength: 1, maxLength: 32 })),
    search: Type.Optional(Type.String()),
    limit: Type.Optional(Type.Integer({ minimum: 1, maximum: 500 })),
    offset: Type.Optional(Type.Integer({ minimum: 0 })),
});
/** Performance figures shown next to each suggestion on the admin page. */
export const SuggestionWithStatsSchema = Type.Composite([
    SuggestionSchema,
    Type.Object({
        shown: Type.Integer(),
        picked: Type.Integer(),
    }),
]);
/** How much of the library sits at one level. */
export const SpiceTotalSchema = Type.Object({
    spice: Type.Enum(SpiceLevel),
    total: Type.Integer(),
});
export const SuggestionListResSchema = Type.Object({
    suggestions: Type.Array(SuggestionWithStatsSchema),
    total: Type.Integer(),
    /**
     * The library's shape, under every filter **except** spice. Filtering to one
     * level must not redraw the balance as 100% of that level — the question the
     * figure answers is what a player is drawing from, which the filter does not
     * change. Levels with nothing at them are present at zero.
     */
    spice_totals: Type.Array(SpiceTotalSchema),
});
/** Bulk import. Duplicates are skipped rather than failing the whole batch. */
export const SuggestionImportReqSchema = Type.Object({
    suggestions: Type.Array(SuggestionInputSchema, { minItems: 1 }),
});
export const SuggestionImportResSchema = Type.Object({
    inserted: Type.Integer(),
    skipped: Type.Integer(),
});
export const SuggestionExportResSchema = Type.Object({
    suggestions: Type.Array(SuggestionInputSchema),
});
